module.exports = __webpack_public_path__ + "img/logo_mi.98be3915.png";